import React, { useState } from "react";
import "./Admin.css"; // import the css

const Admin = () => {
  const [username, setUsername] = useState("");
  const [password, setPassword] = useState("");
  const [mobile, setMobile] = useState("");
  const [email, setEmail] = useState("");
  const [role, setRole] = useState("admin");
  const [modules, setModules] = useState([]);

  const handleModuleChange = (e) => {
    const { value, checked } = e.target;
    setModules((prev) =>
      checked ? [...prev, value] : prev.filter((m) => m !== value)
    );
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    const newAdmin = { username, password, mobile, email, role, modules };
    console.log("New Admin Created:", newAdmin);
  };

  return (
    <div className="uni-bid-form-container">
      <h1 className="form-heading">Add Admin</h1>

      <div className="form-content">
        <form onSubmit={handleSubmit}>
          <div className="form-grid">
            <div className="form-group">
              <label className="form-label">Admin Username</label>
              <input
                type="text"
                value={username}
                onChange={(e) => setUsername(e.target.value)}
                className="form-input"
                required
              />
            </div>
            <div className="form-group">
              <label className="form-label">Email</label>
              <input
                type="email"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                className="form-input"
                required
              />
            </div>
            <div className="form-group">
              <label className="form-label">Password</label>
              <input
                type="password"
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                className="form-input"
                required
              />
            </div>
            <div className="form-group">
              <label className="form-label">Mobile Number</label>
              <input
                type="tel"
                value={mobile}
                onChange={(e) => setMobile(e.target.value)}
                className="form-input"
                required
              />
            </div>
            <div className="form-group">
              <label className="form-label">Admin Role</label>
              <select
                value={role}
                onChange={(e) => setRole(e.target.value)}
                className="form-select"
                required
              >
                <option value="admin">Admin</option>
                <option value="superadmin">Superadmin</option>
                <option value="crm">CRM</option>
              </select>
            </div>
          </div>

          {/* Modules Row */}
          <div className="module-row">
            <label className="module-label">Modules</label>
            <div className="module-options">
              {["dashboard", "markets", "companies", "bid creation", "configure","User-info", "User-Bids"].map(
                (module) => (
                  <label key={module} className="module-option">
                    <input
                      type="checkbox"
                      value={module}
                      checked={modules.includes(module)}
                      onChange={handleModuleChange}
                    />
                    <span>{module}</span>
                  </label>
                )
              )}
            </div>
            
          </div>
<button type="submit" className="admin-form-button">
            Submit
          </button>
          
        </form>
      </div>
    </div>
  );
};

export default Admin;
